<template>
  <div id="breadcrumb" uk-sticky="bottom: #offset">
    <div
      class="uk-section uk-section-secondary uk-padding-remove-top uk-padding-remove-bottom"
      id="page-map"
    >
      <div class="uk-container">
        <div class="uk-flex uk-flex-between uk-flex-middle">
          <div class="uk-flex">
            <ul class="uk-padding-remove uk-margin-remove-bottom">
              <li class="uk-text-uppercase uk-padding-remove-left title" v-if="!isVerySmall">
                <a href="#top-nav" uk-scroll>{{ productName }}</a>
              </li>
              <li
                class="uk-padding-remove-left uk-padding-remove-right"
                style="font-size: smaller !important"
                v-if="!isVerySmall"
              >
                &#x2223;
              </li>
              <li>
                <a href="#MainProductBanner" uk-scroll>OVERVIEW</a>
              </li>
              <li>
                <a href="#spesification" uk-scroll>SPECS</a>
              </li>
              <!-- <li v-if="!isSmall">FAQ</li>
              <li v-if="!isSmall">WHERE TO BUY</li> -->
            </ul>
          </div>
          <!-- <div class="uk-flex">
            <ul class="uk-padding-remove uk-margin-remove-bottom">
              <li class="uk-width-auto">
                <button class="uk-button uk-button-default uk-button-small">
                  Tambah Keranjang
                </button>
              </li>
              <li class="uk-padding-remove-right uk-padding-remove-left uk-width-auto">
                <button class="uk-button uk-button-secondary uk-button-small">
                  Beli Sekarang
                </button>
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["productName"],
  data() {
    return {};
  },
  mounted() {},
  computed: {
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    },
  },
};
</script>

<style scoped lang="less">
#breadcrumb {
  position: relative;
  z-index: 1;
}
ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  /* min-height: 40px !important; */
  /* overflow-y: hidden; */
}

ul li,
ul li.title {
  padding: 10px 20px;
  /* max-height: 20px !important; */
  font-weight: 300;
  color: rgb(255, 255, 255) !important;
  letter-spacing: 0.5px;
  text-align: left;
  font-size: 10px;
  transform: scaleX(1.05);
  transform-origin: left;
  margin-top: auto;
  margin-bottom: auto;
}

@media screen and (max-width: 639px) {
  ul li,
  ul li.title {
    font-size: 10px;
    padding: 10px;
  }
}
</style>